import { PersonalInfoGroup } from 'src/app/admin/admin-home/forms/shared-components/personal-info-group';

export class ApplicationField {
  public fieldName: ApplicationFieldName;
  public displayStatus: ApplicationFieldDisplayStatus;
  public category: PersonalInfoGroup;

  private _fieldRequiresPlanUpgrade: boolean;
  constructor() {}
  public static parse(data: any, fieldRequiresPlanUpgrade = false): ApplicationField {
    if (!data) return null;

    const applicationField = new ApplicationField();
    Object.assign(applicationField, data);
    applicationField._fieldRequiresPlanUpgrade = fieldRequiresPlanUpgrade;
    applicationField.category = ApplicationField.getCategory(applicationField.fieldName);
    return applicationField;
  }

  public get isRequired() {
    if (this._fieldRequiresPlanUpgrade) return false;
    return this.displayStatus == ApplicationFieldDisplayStatus.Required;
  }

  public set isRequired(value) {
    value
      ? (this.displayStatus = ApplicationFieldDisplayStatus.Required)
      : (this.displayStatus = ApplicationFieldDisplayStatus.Optional);
  }

  public get isVisible() {
    if (this._fieldRequiresPlanUpgrade) return false;
    return this.displayStatus != ApplicationFieldDisplayStatus.Hidden;
  }

  public set isVisible(value) {
    value
      ? (this.displayStatus = ApplicationFieldDisplayStatus.Optional)
      : (this.displayStatus = ApplicationFieldDisplayStatus.Hidden);
  }

  public get canBeRequired() {
    return (
      this.fieldName != ApplicationFieldName.Avatar && this.fieldName != ApplicationFieldName.Suffix
    );
  }

  private static getCategory(fieldName: ApplicationFieldName): PersonalInfoGroup {
    if (fieldName == ApplicationFieldName.Gender || fieldName == ApplicationFieldName.Race) {
      return PersonalInfoGroup.DemographicInfo;
    }
    if (
      fieldName == ApplicationFieldName.JobTitle ||
      fieldName == ApplicationFieldName.Company ||
      fieldName == ApplicationFieldName.LinkedIn ||
      fieldName == ApplicationFieldName.Resume
    ) {
      return PersonalInfoGroup.ProfessionalInfo;
    }
    return fieldName == ApplicationFieldName.Avatar ||
      fieldName == ApplicationFieldName.PhoneNumber ||
      fieldName == ApplicationFieldName.Suffix ||
      fieldName == ApplicationFieldName.MiddleName
      ? PersonalInfoGroup.ContactInfo
      : PersonalInfoGroup.MailingAddress;
  }
}

export enum ApplicationFieldName {
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  StateOrProvince = 'StateOrProvince',
  PostalCode = 'PostalCode',
  Country = 'Country',
  JobTitle = 'JobTitle',
  Company = 'Company',
  Resume = 'Resume',
  PhoneNumber = 'PhoneNumber',
  Avatar = 'Avatar',
  Gender = 'Gender',
  Race = 'Race',
  LinkedIn = 'LinkedIn',
  MiddleName = 'MiddleName',
  AddressIsShared = 'AddressIsShared',
  Suffix = 'Suffix',
}

export enum ApplicationFieldDisplayStatus {
  Optional = 'Optional',
  Required = 'Required',
  Hidden = 'Hidden',
}
